import { Button as MuButton } from '@mui/material';
import { createLink } from '@tanstack/react-router';

export const ButtonLink = createLink(MuButton);
